import { Address } from './address';
import { PolicyBase } from './policy';

export interface PolicyCar extends PolicyBase {
  policyBaseType: 'car';

  // INSURANCE COMMON ATTRS
  product: string;
  companyId: string;
  expirationDate: string;
  bank: string;
  iban: string;
  department: string;
  // INSURANCE COMMON ATTRS

  // POLICY-CAR ATTRS
  vehicle: string;
  paymentMethod: string;
  policyType: PolicyCarType;
  frameNumber: string;
  plateNumber: string;
  valueDate: string;
  forms: PolicyCarForm[];
  coverages: string[];
  generalConditionsCode: string;
  superbonusData: Superbonus;
  rentingPolicy?: boolean;
  hasSuperbonus?: boolean; // Template attr
  chargers?: CarCharger[];
  cardNumber: string;
  cardExpirationDate: string;
  onOffPolicy?: boolean;
  onOffPackageName?: string;
  onOffNumActivations?: string;
  onOffNumMaxActivations?: string;
  onOffActivated?: boolean;
  onOffStatusDate?: string;
  onOffCoverages?: string [];
  onOffDigitalVerification?: boolean;
  // POLICY-CAR ATTRS
}

export interface PolicyCarForm {
  id: string;
  name: string;
  surname1: string;
  surname2: string;
  documentNumber: string;
  birthdate: string;
  permissionDate: string;
  maritalStatus: string;
  mobilePhone: string;
  gender: string;
  email: string;
  address: Address;
  phone: string;
  permissionType: string;
  habitualDriver: boolean;
  casualDriver: boolean;
  otherDriver: boolean;
  holder: boolean;
  owner: boolean;
  representative: boolean;
  payer: boolean;
  insured: boolean;
  socialReason?: string;
  formTitle?: string;
  formAddressTitle?: string;
}

export enum PolicyCarType {
  GENERAL = 'GENERAL',
  YCAR = 'YCAR',
  ECO = 'ECO'
}

export interface Superbonus {
  statusCode: keyof typeof SuperbonusStatus;
  statusDate?: string;
  offers?: SuperbonusOffer[];
  exchangedAmount?: number;
  exchangedPaymentMethod?: SuperbonusOfferType;
}

export interface SuperbonusOffer {
  paymentMethod: SuperbonusOfferType;
  amount: number;
}

export enum SuperbonusStatus {
  CG = 'CG - POTENCIAL GANADOR',
  LM = 'LM - PENDIENTE DE LIQUIDACION',
  TM = 'TM - PAGO EN TRAMITACION',
  LQ = 'LQ - LIQUIDADO'
}

export type SuperbonusOfferType = 'D' | 'TR';

export const SUPERBONUS_LQ_STATUS_AVAILABILITY_TIME_IN_MONTHS = 4;

export interface CarCharger {
  id: string;
  brand: string;
  model: string;
  serialNumber: string;
  address: Address;
}

export const isElectricVehiclePolicy = (policy: PolicyCar) => policy?.companyId === '41' && policy.department === '200';

export const isOnOffPolicyWithPackage = (policy: PolicyCar) => policy?.onOffPolicy && !!policy?.onOffPackageName;

export const isActivationsLimitReached = (policy: PolicyCar) => policy?.onOffNumActivations === policy?.onOffNumMaxActivations;
